import { createContext,useState } from "react";
import SnackBar from "../components/SnackBar";
export const TostContext = createContext({});

export const ToastProvider = ({children})=>{
    const [open, setOpen] =useState(false);
    const [MessageTost,setMessage]=useState("")
    
    function showHideToastAlert(message){
        setOpen(true);
        setMessage(message);
        setTimeout(()=>{
        setOpen(false)
        },3000)
    };
    return (
        <TostContext.Provider value={{showHideToastAlert}}>
            <SnackBar open={open} title={MessageTost} />
            {children}
        </TostContext.Provider>
    )
    
}